export default "__VITE_ASSET__ByGQc$8k__"